export default __webpack_public_path__ + "static/media/cloudez.66cfaa06.svg";